import SelectMetric from './SelectMetric';

export default SelectMetric;